// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "../../core/Env.res.js";
import * as React from "react";
import * as Auth__Jwt from "./Auth__Jwt.res.js";
import * as Auth__Mock from "./Auth__Mock.res.js";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as Auth__Reducer from "./Auth__Reducer.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as ReactUpdateReducer from "../../primitives/ReactUpdateReducer.res.js";

let storageKey = "auth";

let context = React.createContext([
  undefined,
  param => {}
]);

function use() {
  let match = React.useContext(context);
  let state = match[0];
  if (state !== undefined) {
    return [
      state,
      match[1]
    ];
  } else {
    return Pervasives.failwith("Could not find Auth context value");
  }
}

function createState(initialState, param) {
  let mounted = React.useRef(false);
  let match = ReactUpdateReducer.useWithMapState(Auth__Reducer.make, () => {
    let match = Auth__Jwt.get();
    if (initialState !== undefined) {
      if (match !== undefined) {
        return initialState;
      } else {
        return "Unlogged";
      }
    }
    if (match === undefined) {
      return "Unlogged";
    }
    let match$1 = Stdlib_Option.map(Primitive_option.fromNull(localStorage.getItem(storageKey)), Auth__Reducer.parse);
    if (match$1 === undefined) {
      return "Unlogged";
    }
    if (match$1.TAG !== "Ok") {
      return "Unlogged";
    }
    let auth = match$1._0;
    if (auth.user.canUseImpersonation) {
      return {
        TAG: "Logging",
        jwt: match,
        impersonating: Auth__Jwt.isImpersonated(match)
      };
    } else {
      return {
        TAG: "Logged",
        _0: auth
      };
    }
  });
  let dispatch = match[1];
  let state = match[0];
  React.useEffect(() => {
    if (!mounted.current && Env.context() !== "test") {
      let match = Auth__Jwt.get();
      if (typeof state === "object") {
        if (state.TAG === "Logging") {
          let impersonating = state.impersonating;
          if (impersonating !== undefined && match !== undefined) {
            dispatch({
              TAG: "LogRequested",
              jwt: match,
              impersonate: impersonating
            });
          }
        } else if (state._0.user.impersonating || match === undefined) {
          
        } else {
          dispatch({
            TAG: "LogRequested",
            jwt: match
          });
        }
      }
    }
  }, []);
  React.useEffect(() => {
    if (mounted.current) {
      let match = Auth__Reducer.stringify(state);
      if (typeof state === "object" && state.TAG !== "Logging") {
        if (state._0.user.impersonating || match === undefined) {
          
        } else {
          localStorage.setItem(storageKey, match);
        }
      }
    }
    if (typeof state !== "object") {
      localStorage.removeItem(storageKey);
      Auth__Jwt.remove();
    } else if (state.TAG === "Logging") {
      Auth__Jwt.set(state.jwt, state.impersonating, undefined);
    }
  }, [state]);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return [
    state,
    dispatch
  ];
}

let make = context.Provider;

let ContextProvider = {
  make: make
};

let contextProvider = context.Provider;

function Auth__Context$Provider(props) {
  let initialState = props.initialState;
  let match = Env.context();
  let initialState$1 = initialState !== undefined ? initialState : (
      match === "test" ? ({
          TAG: "Logged",
          _0: Auth__Mock.mockAuthState(undefined, undefined, undefined)
        }) : undefined
    );
  let value = createState(initialState$1, undefined);
  return JsxRuntime.jsx(make, {
    value: value,
    children: props.children
  });
}

let Provider = {
  contextProvider: contextProvider,
  make: Auth__Context$Provider
};

let Reducer;

let Mock;

let Jwt;

export {
  Reducer,
  Mock,
  Jwt,
  storageKey,
  context,
  use,
  createState,
  ContextProvider,
  Provider,
}
/* context Not a pure module */
